export default __webpack_public_path__ + "static/media/boitef2.b2c5c9a2.png";